/* eslint-disable complexity */
/* eslint-disable max-lines-per-function */
import React, { memo, useEffect, useState } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { withRouter } from '~HOC';
import { connect } from 'react-redux';
import { fileHandlerUrl } from '../../../utils/consts/server';
import { profileApi } from '../../../services/apis';
import { setToken } from '../../../actions/requestToken';
import {
  numberWithCommas,
  flightBookingRoutes,
  profileRoutes,
} from '../../../utils/consts';
import { Toast } from '../../common';
import {
  ChevronLeftIcon,
  ChevronRightIcon,
} from '../../../content/svg-component';
import './index.scss';

const StackHolder = (props) => {
  let activeProfile = localStorage.getItem('profile');
  const isUpdateProfile = localStorage.getItem('isUpdateProfile');
  const [currentProfile, setCurrentProfile] = useState('');
  const [profiletype, setProfiletype] = useState('');
  const [selectedProfileId, setSelectedProfileId] = useState('');
  const [profileMenuArray, setProfileMenuArray] = useState([]);
  const [showCollapse, setShowCollapse] = useState(false);
  const [toast, setToast] = useState(false);
  const [toastState, setToastState] = useState('success');
  const [alertMessage, setAlertMessage] = useState('profile.notallowed');
  const [links, setLinks] = useState([
    { name: 'header.dashboard', link: '/profile/dashboard' },
    { name: 'header.book', link: '/booking/select-city' },
    {
      name: 'header.Booking',
      link: `/profile/booking-flights${
        activeProfile && activeProfile !== 'individual'
          ? `?id=${activeProfile}`
          : ''
      }`,
    },
    { name: 'header.ticket', link: '/profile/ticket' },
    { name: 'header.logout', link: '/login' },
  ]);
  const [changeProfile, setChangeProfile] = useState({
    flag: false,
    profile: '',
  });
  const INVALID_ROUTE = [
    '/booking/select-flight',
    '/booking/identify',
    '/booking/select-login-type',
    '/booking/flight-invoice',
  ];
  const {
    language: { direction, name },
    language,
    CloseMobileMenu = () => {},
  } = props;

  useEffect(() => {
    if (selectedProfileId) {
      if (props?.onChange) {
        const temp = profileMenuArray.find(
          (item) =>
            item.selectedProfileId === (selectedProfileId || 'individual'),
        );

        props.onChange(
          selectedProfileId === 'individual' ? 'individual' : 'business',
          temp,
          false,
        );
      }
    }
  }, [selectedProfileId]);

  useEffect(() => {
    const currentProfileType = localStorage.getItem('profile');
    const temp = profileMenuArray.find(
      (item) => item.id === currentProfileType,
    );
    if (selectedProfileId !== currentProfileType) {
      if (temp) {
        getProfile();
        handleChangeProfile(temp);
      }
    }
    if (
      props.location.pathname === profileRoutes.sendProfileForVerification &&
      currentProfileType === 'individual'
    ) {
      getProfile();
    }

    // &&
    //   currentProfileType !== 'individual'
    else if (
      props.location.pathname === profileRoutes.userBasicInfo &&
      isUpdateProfile
    ) {
      getProfile();
      props.onChange(
        selectedProfileId === 'individual' ? 'individual' : 'business',
        temp,
        true,
      );
      setChangeProfile({ flag: true, profile: profileMenuArray?.[0] });
      localStorage.removeItem('isUpdateProfile');
    }
  }, [props.location.pathname]);

  // useEffect(() => {
  //   changeProfile.flag && handleChangeProfile(changeProfile.profile);
  //   getProfile();
  //   let businessProfiles = businessProfilesFilter();
  //   let indivisualProfile = profileMenuArray.filter((item) => {
  //     return item?.selectedProfileId === 'individual';
  //   });
  //   console.log('data is : ', businessProfiles);
  //   setProfileMenuArray([...indivisualProfile, ...businessProfiles]);
  // }, [changeProfile]);
  useEffect(() => {
    changeProfile.flag && handleChangeProfile(changeProfile.profile);
  }, [changeProfile]);

  useEffect(() => {
    getProfile();
  }, []);

  const getProfile = () => {
    profileMenuArray.length = 0;
    setProfileMenuArray(profileMenuArray);
    const { user, profiles } = props.userInfo || {},
      { name } = props.language;
    let profileId = localStorage.getItem('profile'),
      fullName = user?.[0] ? `${user[0].firstName} ${user[0].lastName}` : '',
      item = {
        id: user?.[0].profileId,
        title: fullName.length > 10 ? fullName : '',
        fullName: fullName,
        image: user?.[0]?.basicInfo?.avatar
          ? require(`../../../content/images/avatars/${user[0].basicInfo.avatar}`)
          : '',
        creditAmount:
          user?.[0]?.creditAmount?.remain > 0 ? user[0].creditAmount.remain : 0,
        walletAmount:
          user?.[0]?.walletAmount?.remain > 0 ? user[0].walletAmount.remain : 0,
        businessType: props.intl.formatMessage({
          id: 'profile.personalprofile',
        }),
        isLock: '',
        selectedProfileId: 'individual',
        profileRoute: `/profile/user-basic-info`,
      };

    profileMenuArray.push(item);
    setProfileMenuArray(profileMenuArray);

    if (profiles && profiles.length) {
      profiles.map((profile) => {
        item = {
          id: profile.profileId,
          fullName:
            profile?.profile?.displayName?.[name === 'fa' ? 'fa' : 'en'],
          title:
            profile?.profile?.displayName?.[name === 'fa' ? 'fa' : 'en'] ?? '',
          image: profile?.profile?.basicInfo?.logo
            ? `${fileHandlerUrl}/file/show/${profile?.profile?.basicInfo?.logo}`
            : '',
          creditAmount:
            profile?.profile?.creditAmount?.flight?.remain > 0
              ? profile?.profile?.creditAmount?.flight?.remain
              : 0,
          walletAmount:
            profile?.profile?.walletAmount?.remain > 0
              ? profile.profile.walletAmount.remain
              : 0,
          moneyUnit: profile?.profile?.walletAmount?.moneyUnit?.moneyUnit ?? 0,
          businessType:
            profile?.profile?.businessType?.name?.[name | 'en'] ?? '',
          isLock: profile?.profile?.isLock,
          isApproved: profile?.profile?.isApproved,
          selectedProfileId: profile.profileId,
          profileRoute: `/profile/business-profile?id=${profile.profileId}`,
        };
        if (
          !profileMenuArray.filter((profile) => profile.id === item.id).length
        ) {
          profileMenuArray.push(item);
          setProfileMenuArray(profileMenuArray);
        }
      });
    }

    if (profileId && user) {
      let selectedProfile =
        profileId !== 'individual'
          ? profiles &&
            profiles?.filter(
              (item) => item?.profile?.id === parseInt(profileId),
            )?.[0]?.profile
          : `${user?.[0]?.firstName} ${user?.[0]?.lastName}`;
      links[3].link = `/profile/booking-flights${
        profileId && profileId !== 'individual' ? `?id=${profileId}` : ''
      }`;
      profileId =
        profileId === 'individual' ? 'individual' : parseInt(profileId);
      setLinks(links);
      setSelectedProfileId(profileId);
      setProfiletype(
        profileId === 'individual'
          ? selectedProfile
          : selectedProfile?.displayName?.[name] ??
              selectedProfile?.displayName?.['en'],
      );
      setCurrentProfile((prev) => [...prev, profileId]);
    }
    if (profileId === '') {
      setSelectedProfileId('individual');
    }
  };
  const handleChangeProfile = (profile) => {
    let parsedQueryStr = '';
    profileApi
      .activeProfile(profile.id)
      .then((result) => {
        if (result.status === 200) {
          localStorage.setItem('stakeholder', JSON.stringify(profile.id));
          localStorage.setItem('profile', profile.selectedProfileId);
          props.setToken(result?.payload?.data?.token || '');
          setSelectedProfileId(profile.selectedProfileId);
          setProfiletype(profile.fullName);
          if (props.location.pathname.includes('profile')) props.navigate(0);

          if (INVALID_ROUTE.includes(props.location.pathname)) {
            parsedQueryStr = Object.fromEntries(
              new URLSearchParams(props?.location?.search),
            );
            parsedQueryStr.reset = '1';
            props.navigate(
              `${flightBookingRoutes.selectFlight}/?${new URLSearchParams(
                parsedQueryStr,
              ).toString()}`,
            );
          }
        }
      })
      .catch((error) => {
        if (profile.isLock === false && profile.isApproved === false) {
          props.navigate(profileRoutes.editIsLockbusinessProfile, {
            state: { profileId: profile.id },
          });
        } else {
          setAlertMessage('profile.notallowed');
          setToast(true);
          setToastState('danger');
        }
      });
    setChangeProfile({ flag: false, profile: '' });
  };

  // const businessProfilesFilter = () => {
  //   let allowedProfiles = [];
  //   let profileMenuFormat = [];

  //   allowedProfiles = props?.userData?.profiles.filter((profile) => {
  //     let findMainRole = profile?.roles?.find((item) => {
  //       return item?.id === 60 || item?.id === 63 || item?.id === 10;
  //     });

  //     return profile?.roles?.includes(findMainRole);
  //   });

  //   allowedProfiles?.map((item) => {
  //     let profile = item.profile;
  //     item = {
  //       id: profile.id,
  //       fullName: profile?.displayName?.[language?.name || 'en'],
  //       title: profile?.displayName?.[language?.name || 'en'] ?? '',
  //       image: profile?.basicInfo?.logo
  //         ? `${fileHandlerUrl}/file/show/${profile?.basicInfo?.logo}`
  //         : '',
  //       creditAmount:
  //         profile?.creditAmount?.remain > 0 ? profile.creditAmount.remain : 0,
  //       walletAmount:
  //         profile?.profile?.walletAmount?.remain > 0
  //           ? profile?.walletAmount?.remain
  //           : 0,
  //       businessType:
  //         profile?.businessType?.name?.[language?.name || 'en'] ?? '',
  //       isLock: profile?.isLock,
  //       isActive: profile?.isActive,
  //       selectedProfileId: profile?.id,
  //       profileRoute: `/profile/business-profile?id=${profile?.id}`,
  //     };
  //     profileMenuFormat.push(item);
  //   });

  //   return profileMenuFormat;
  // };

  return (
    <div className="position-relative stackeHolder-container w-100">
      <div
        onClick={() => setShowCollapse(!showCollapse)}
        data-toggle="collapse"
        data-target="#collapseStakholder"
        aria-expanded="true"
        aria-controls="collapseStakholder"
        className="p-0 dropdown-toggle d-flex align-items-center text-white cursor-pointer w-100"
      >
        <Toast
          isOpen={toast}
          onClose={() => setToast(false)}
          state={toastState}
          position="bottom"
          message={props.intl.formatMessage({
            id: alertMessage,
          })}
          direction={direction}
        />
        <span
          className={`font-normal px-2 text-uppercase text-wrap d-lg-inline text-truncate ${
            direction === 'ltr' ? 'text-left' : 'text-right'
          }`}
        >
          {currentProfile !== 'individual' &&
          profiletype !== '' &&
          profiletype !== 'individual' ? (
            profiletype
          ) : (
            <FormattedMessage id="profile.personalprofile" />
          )}
        </span>
      </div>
      {showCollapse ? (
        <div
          id="collapseStakholder"
          className="d-flex width-menu justify-content-center align-items-center position-absolute shadow-lg show"
          style={{ top: 40, zIndex: 10000 }}
        >
          <ul
            id="optionList"
            style={{ maxHeight: '20rem' }}
            className={`p-0 mb-0 list-unstyled text-dark overflow-auto rounded bg-third border border-2 default-border-radius-small border-third  position-static w-100 `}
          >
            {profileMenuArray?.map((item, index) => (
              <li
                key={`profile-menu-array-${item.id}-${index}`}
                onClick={() => {
                  const currentProfileId = localStorage.getItem('stakeholder');
                  if (currentProfileId != item.id) {
                    setChangeProfile({ flag: true, profile: item });
                    CloseMobileMenu();
                    setShowCollapse(false);
                  }
                }}
                className={`py-0 px-1 position-relative 
                ${index === 0 && 'rounded-top'}
                ${
                  index === profileMenuArray.length - 1
                    ? 'rounded-bottom'
                    : 'border-bottom border-third'
                }
                ${
                  selectedProfileId === item.selectedProfileId
                    ? 'bg-secondary text-white'
                    : 'bg-white'
                }
                cursor-pointer d-flex px-2`}
              >
                <div className="col-9 px-0 d-flex flex-row my-2">
                  <div
                    className={`d-flex align-items-center ${
                      item.image &&
                      'p-1 border border-third border-2 rounded-circle'
                    }`}
                    style={{ width: '40px', height: '40px' }}
                  >
                    {item.image ? (
                      <img
                        alt="img"
                        width="100%"
                        height="100%"
                        className="rounded-circle"
                        src={item.image}
                      />
                    ) : (
                      <div className=" d-flex align-items-center">
                        <div
                          className="rounded-circle border border-primary text-primary-dark d-flex align-items-center"
                          style={{ width: 40, height: 40 }}
                        >
                          <span className="m-auto font-xsmall">
                            <FormattedMessage id="profile.logo" />
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="col-8 d-flex flex-column align-items-start font-msmall font-sm-tiny py-0 px-2">
                    <div
                      title={item.title}
                      className={`${
                        direction === 'ltr' && name !== 'ar'
                          ? ' font-smaller'
                          : ' font-small'
                      } w-100 d-flex flex-column text-uppercase font-weight-bold text-wrap text-start`}
                    >
                      {item.fullName}
                      <span
                        className={`text-start font-xsmall font-sm-tiny font-weight-bold text-nowrap`}
                      >
                        (
                        {item.businessType ? (
                          item.businessType
                        ) : (
                          <FormattedMessage id="profile.businessprofile" />
                        )}
                        )
                      </span>
                    </div>
                    <div className="w-100 d-flex align-items-start justify-content-between mt-1">
                      <div className="col-7 d-flex flex-column justify-content-center font-xsmall font-weight-bold p-0">
                        <div className="d-flex text-nowrap">
                          <FormattedMessage id="profile.wallet" />
                          <span
                            className={`px-1 ${
                              direction === 'ltr' && 'font-tiny'
                            }`}
                          >
                            {item.walletAmount > 0
                              ? numberWithCommas(
                                  Number(
                                    item.walletAmount /
                                      (item.moneyUnit === 'IRR' ? 10 : 1),
                                  ).toFixed(0),
                                )
                              : 0}
                          </span>
                        </div>
                        <div className="d-flex text-nowrap">
                          <FormattedMessage id="profile.menucredit" />
                          <span
                            className={`px-1 ${
                              direction === 'ltr' && 'font-tiny'
                            }`}
                          >
                            {item.creditAmount > 0
                              ? numberWithCommas(
                                  Number(
                                    item.creditAmount /
                                      (item.moneyUnit === 'IRR' ? 10 : 1),
                                  ).toFixed(0),
                                )
                              : 0}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className={
                    'col-3 d-flex flex-column align-items-center px-0 text-center pt-3'
                  }
                >
                  <div className={`w-100 font-smaller py-1 text-white`}>
                    {item.isLock === false && item.isApproved === false ? (
                      <div className="col-11 bg-danger default-border-radius-small px-1">
                        <FormattedMessage id="profile.dissapprove" />
                      </div>
                    ) : (
                      item.isLock === true && (
                        <div
                          className={`${
                            direction === 'ltr' && 'font-xsmall py-1'
                          } col-11 bg-forth default-border-radius-small px-1`}
                        >
                          <FormattedMessage id="profile.suspend" />
                        </div>
                      )
                    )}
                  </div>
                  {direction === 'rtl' ? (
                    <ChevronLeftIcon
                      size={18}
                      color={'#aaacaf'}
                      variant={'pt-2'}
                    />
                  ) : (
                    <ChevronRightIcon
                      size={18}
                      color={'#aaacaf'}
                      variant={'pt-2'}
                    />
                  )}
                </div>
              </li>
            ))}
          </ul>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

StackHolder.propTypes = {};

function mapStateToProps(state, props) {
  return {
    language: state.language,
    userInfo: state?.user?.userInfo,
  };
}

export default injectIntl(
  withRouter(connect(mapStateToProps, { setToken })(memo(StackHolder))),
);
